import { render } from "./WorkPage.vue?vue&type=template&id=182ed9a7&scoped=true"
import script from "./WorkPage.vue?vue&type=script&lang=js"
export * from "./WorkPage.vue?vue&type=script&lang=js"

import "./WorkPage.vue?vue&type=style&index=0&id=182ed9a7&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-182ed9a7"]])

export default __exports__